import { Common, ApiBind } from './common.model';

export class DealDetail extends Common {
  @ApiBind({ column: 'id' })
  id: number;

  @ApiBind({ column: 'deal_id' })
  dealId: number;

  @ApiBind({ column: 'seq' })
  seq: number;

  @ApiBind({ column: 'outer_deal_id' })
  outerDealId: string;

  @ApiBind({ column: 'cpm' })
  cpm: number;

  @ApiBind({ column: 'memo' })
  memo: string;

  @ApiBind({ column: 'updated_at' })
  updatedAt: string;

}
